import EditableItem from './EditableItem';
import AttachedEquipmentForm from './AttachedEquipmentForm';

export default {
  EditableItem,
  AttachedEquipmentForm
};
